<template>
    <b-row class="ld-over" :class="[{'running': dataLoading}]">
        <div class="ld ld-ring ld-spin" v-if="dataLoading"></div>

        <b-col xxs="12">
            <div class="mb-2 mt-2">
                <b-button variant="empty" class="pt-0 pl-0 d-inline-block d-md-none" v-b-toggle.displayOptions>
                    pages.display-options
                    <i class="simple-icon-arrow-down align-middle"/>
                </b-button>

                <b-collapse id="displayOptions" class="d-md-block">
                    <div class="d-block d-md-inline-block pt-1" v-show="showSearchBox">
                        <div class="search-sm d-inline-block float-md-left mr-1 align-top">
                            <b-input placeholder="Search" v-model="search"/>
                        </div>
                    </div>

                    <div class="float-md-right pt-1">
                        <span class="text-muted text-small mr-1 mb-2">{{ from }}-{{ to }} of {{ total }}</span>

                        <b-dropdown right :text="`${perPageValue}`" variant="outline-dark" class="d-inline-block"
                                    size="xs">
                            <b-dropdown-item v-for="(size,index) in pageSizes" :key="index"
                                             @click="changePageSize(size)">{{ size }}
                            </b-dropdown-item>
                        </b-dropdown>

                    </div>
                </b-collapse>
            </div>
            <div class="separator mb-5" v-show="showBorder"></div>

            <div class="loading" v-show="error">
                <slot name="error">
                    <div class="alert alert-danger">
                        <error-icon/>
                        Loading Data Failed.
                    </div>
                </slot>
            </div>

            <vuetable ref="vuetable" class="order-with-arrow" pagination-path :api-url="url" :per-page="perPageValue"
                      :reactive-api-url="true" :fields="fields"
                      @vuetable:pagination-data="onPaginationData" @vuetable:loading="showLoadingAnimation"
                      @vuetable:load-success="hideLoadingAnimation" @vuetable:load-error="setError"
                      :query-params="makeQueryParams" v-show="!error" :load-on-start="loadOnStart">

                <!--suppress XmlUnboundNsPrefix, JSUnusedLocalSymbols -->
                <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                    <slot :name="slot" v-bind="scope"/>
                </template>

            </vuetable>
            <vuetable-pagination-bootstrap
                v-show="showPagination" class="mt-4" ref="pagination"
                @vuetable-pagination:change-page="onChangePage"/>
        </b-col>
    </b-row>
</template>

<script>
import VueTableMixin from './VueTableMixin';

export default {
    name: 'vue-table',
    mixins: [VueTableMixin],
    props: {
        pageSizes: {
            type: Array,
            default: () => [4, 8, 12]
        },

        showBorder: {
            type: Boolean,
            default: false
        },

        showSearchBox: {
            type: Boolean,
            default: true
        },

        filters: {
            type: Array,
            default () {
                return [];
            }
        }
    },

    data: function () {
        return {
            error: false
        };
    },

    methods: {}

};
</script>
